// extracted by mini-css-extract-plugin
export default {"Description":"BJ8sK8vf15SW3MamPxaj4w==","NoPadding":"dknDUzXU92SgdTMyO+-r-A=="};